import actionItems from "../project-review/actionItems";

export default function () {
    actionItems();
    loadAccrualStatuses();
}

const loadAccrualStatuses = () => {
    const $accrualStatuses = $('.accrual-statuses');

    if ($accrualStatuses.length) {
        $accrualStatuses.load('/Account/Dashboard/UserPmCounts', function () {
            pmChangeEvent();
        })
    }
}

const pmChangeEvent = () => {
    const $pmDropdown = $('#projectManagers');

    if ($pmDropdown.length) {
        $pmDropdown.on('change', function () {
            $('.pm-accrual-info').hide();
            $(`[data-pm-number="${this.value}"]`).show();
        });
    }
}